/**
 * _shared.js — Общие импорты и утилиты для всех API-модулей.
 * Каждый модуль импортирует отсюда то, что ему нужно.
 */
import { supabase, isSupabaseConfigured as envSupabaseConfigured, proxyStorageUrl } from '../supabase'
import { demoStorage, demoEmployees, salaryConfig as demoSalaryConfig, calculateAutoSalary as demoCalcSalary } from '../demoStore'
import apiClient from '../apiClient'

export { supabase, proxyStorageUrl, demoStorage, demoEmployees, demoSalaryConfig, demoCalcSalary, apiClient }

export let isSupabaseConfigured = envSupabaseConfigured
export function setForceDemoMode() { isSupabaseConfigured = false }

// ─── LOCAL STORAGE CACHE ENGINE ──────────────────────────────
const CACHE_PREFIX = 'wb_cache_'

export function getCache(key) {
  try {
    const val = localStorage.getItem(CACHE_PREFIX + key)
    if (!val) return null
    const parsed = JSON.parse(val)
    if (Date.now() - parsed.timestamp > 3600000) {
      localStorage.removeItem(CACHE_PREFIX + key)
      return null
    }
    return parsed.data
  } catch (e) {
    return null
  }
}

export function setCache(key, data) {
  try {
    localStorage.setItem(CACHE_PREFIX + key, JSON.stringify({ data, timestamp: Date.now() }))
  } catch (e) {
    console.warn('Cache write error:', e)
  }
}

export function clearCache(pattern = '') {
  try {
    const keysToRemove = []
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i)
      if (key && key.startsWith(CACHE_PREFIX) && key.includes(pattern)) {
        keysToRemove.push(key)
      }
    }
    keysToRemove.forEach(k => localStorage.removeItem(k))
  } catch (e) {}
}

let activePvzId = null
export function setActivePvzId(id) { 
  activePvzId = id 
  clearCache()
}
export function getActivePvzId() { return activePvzId || localStorage.getItem('wb_active_pvz_id') }
